import React, { useEffect, useState } from 'react';

export function useDimensions() {
  const ref = React.useRef();
  const [dimensions, setDimensions] = React.useState({
    offsetHeight: 0,
    offsetWidth: 0,
  });
  const dimensionsRef = React.useRef(dimensions);
  const [resizeObserver] = React.useState(
    () => new ResizeObserver(() => {
      if (ref.current) {
        let changed = false;
        if (dimensionsRef.current.offsetHeight !== ref.current.offsetHeight) {
          changed = true;
          dimensionsRef.current.offsetHeight = dimensionsRef.current.offsetHeight;
        }
        if (dimensionsRef.current.offsetWidth !== ref.current.offsetWidth) {
          changed = true;
          dimensionsRef.current.offsetWidth = dimensionsRef.current.offsetWidth;
        }
        if (changed) {
          setDimensions({ offsetHeight: ref.current.offsetHeight, offsetWidth: ref.current.offsetWidth });
        }
      }
    }),
  );
  React.useLayoutEffect(() => {
    if (ref.current) {
      setDimensions({ offsetHeight: ref.current.offsetHeight, offsetWidth: ref.current.offsetWidth });
      resizeObserver.observe(ref.current, {});
    }
    return () => resizeObserver.disconnect();
  }, [ref.current]);

  return [ref, dimensions];
}

export function useHeight() {
  const [ref, dimensions] = useDimensions();
  return [ref, dimensions.offsetHeight];
}

export function useWidth() {
  const [ref, dimensions] = useDimensions();
  return [ref, dimensions.offsetWidth];
}

export function useViewportHeight() {
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const updateHeight = () => {
      setHeight(window.innerHeight);
    };
    window.addEventListener('resize', updateHeight);
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  return height;
}
